
import * as authHelper from '../../app/modules/auth/core/AuthHelpers'
// import { AuthModel } from '../../app/modules/auth';
import { User } from '../../app/modules/apps/user-management/users-list/core/_models'
import { Response as oResponse } from '../../_metronic/helpers'
import { LanguageHelp, getConfig } from '../../_metronic/helpers/LanguageHelper'


export function getMonthName(monthNumber: number) {
  const date = new Date();
  date.setMonth(monthNumber - 1);
  const lang = getConfig()
  // Using the browser's default locale.
  return date.toLocaleString(lang.selectedLang, { month: 'long' });
}

export function getDateFromText(text: string) {
  const [day, month, yearAndTime] = text.split(".");
  const [year, time] = yearAndTime.split(" ");
  const [hour, minute] = time.split(":");

  return new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);
}

// export function getTimeAgoFromDate(date: Date): string {
export function getTimeAgoFromDate(date: Date) {
  if (!date) return "";

  const now = new Date();
  const diffMs = now.getTime() - new Date(date).getTime();

  const sec = Math.floor(diffMs / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);
  const month = Math.floor(day / 30);
  const year = Math.floor(day / 365);

  const f = (v: number, u: string) => `${v} ${u}${v > 1 ? "s" : ""} ago`;

  if (year >= 1) return f(year, "year");
  if (month >= 1) return f(month, "month");
  if (day >= 1) return f(day + 1, "day");
  if (hr >= 1) return f(hr + 1, "hour");
  if (min >= 1) return f(min + 1, "min");
  if (sec >= 5) return f(sec, "sec");
  return "Just now";
}

export function formatDate(date: Date, locale: string, showTime: boolean = true): string {
  const options: Intl.DateTimeFormatOptions = showTime
    ? { dateStyle: 'short', timeStyle: 'short' }
    : { dateStyle: 'short' };

  return new Date(date).toLocaleString(locale, options);
}

export function formatDateWithTodayControl(dateString?: string | null): string {
  if (!dateString) return "";

  const [day, month, yearAndTime] = dateString.split(".");
  if (!day || !month || !yearAndTime) return "";

  const [year, time] = yearAndTime.split(" ");
  if (!year || !time) return "";

  const [hour, minute] = time.split(":");
  if (!hour || !minute) return "";

  const parsedDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);
  if (isNaN(parsedDate.getTime())) return "";

  const today = new Date();

  const isSameDay =
    parsedDate.getFullYear() === today.getFullYear() &&
    parsedDate.getMonth() === today.getMonth() &&
    parsedDate.getDate() === today.getDate();

  return isSameDay ? `${hour}:${minute}` : `${day}.${month}.${year} ${hour}:${minute}`;
}

export function toLocalDateTimeString(value: any) {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

export function getUserRole(role: number | undefined) {
  switch (role) {
    case 2: { return LanguageHelp("Agent"); }
    case 3: { return LanguageHelp("Admin"); }
    case 6: { return LanguageHelp("Account Owner"); }
    case 8: { return LanguageHelp("Reporter"); }
    default: { return LanguageHelp("Agent"); }
  }
}

export function getUserRoleEnum(role: string) {
  switch (role) {
    case "Agent": { return 2; }
    case "Admin": { return 3; }
    case "Account Owner": { return 6; }
    case "Reporter": { return 8; }
    default: { return 0; }
  }
}

export function convertUserToDashboardModel(agent: any) {
  let auth: any = authHelper.getAuth()
  var parsedAgent: User = {
    id: agent.id,
    name: agent.name + " " + agent.surname,
    avatar: agent.avatarUrl,
    email: agent.email,
    // position: "",
    role: getUserRole(agent.role),
    lastLogin: getTimeAgoFromDate(agent.lastLogoutDate),
    isOnline: false,
    joinedDay: formatDate(agent.lastLogoutDate, auth?.result.language),//10 Nov 2022, 9:23 pm
    online: true,
    initials: {
      label: "",
      state: ""
    },
  };

  return parsedAgent;
}

export function getQueryStringValues(queryString: string) {
  return new URLSearchParams(queryString);
  //const value = urlParams.get('code')
}

export function convertReviewToDashboardModel(agent: any) {
  let auth: any = authHelper.getAuth()
  var parsedAgent: User = {
    id: agent.id,
    name: agent.name + " " + agent.surname,
    avatar: agent.avatarUrl,
    email: agent.email,
    // position: "",
    role: getUserRole(agent.role),
    lastLogin: getTimeAgoFromDate(agent.lastLogoutDate),
    isOnline: false,
    joinedDay: formatDate(agent.lastLogoutDate, auth?.result.language),//10 Nov 2022, 9:23 pm
    online: true,
    initials: {
      label: "",
      state: ""
    },
  };

  return parsedAgent;
}

export function convertTokenToDashboardModel(agent: any) {
  let auth: any = authHelper.getAuth()
  var parsedAgent: User = {
    id: agent.id,
    name: agent.name + " " + agent.surname,
    avatar: agent.avatarUrl,
    email: agent.email,
    // position: "",
    role: getUserRole(agent.role),
    lastLogin: getTimeAgoFromDate(agent.lastLogoutDate),
    isOnline: false,
    joinedDay: formatDate(agent.lastLogoutDate, auth?.result.language),//10 Nov 2022, 9:23 pm
    online: true,
    initials: {
      label: "",
      state: ""
    },
  };

  return parsedAgent;
}

export function convertTimeAgo(timeContent: string | undefined) {
  timeContent = (timeContent as string)
    .replace('month ago', LanguageHelp('month ago'))
    .replace('days ago', LanguageHelp('days ago'))
    .replace('hours ago', LanguageHelp('hours ago'))
    .replace('mins ago', LanguageHelp('mins ago'))
    .replace('seconds ago', LanguageHelp('seconds ago'))
    .replace('Just now', LanguageHelp('Just now'))

  return timeContent;
}

export class Select2Option {
  value = "";
  label = "";
  color = "";
  isFixed?: boolean;
  isDisabled?: boolean;
  // constructor() {
  // }
  constructor(value: string, label: string = "") {
    this.value = value.replaceAll("&", "asc38");
    this.label = label === "" ? value : label;
  }
}

export function combineSelect2Values(myArray: any[]) {
  return myArray == null ? "" : myArray.map(field => field.label).join(', ');
}

export function convertStringsSelect2Values(myArray: string[]) {
  return myArray.map(field => new Select2Option(field));
}

export function getHappinessScore(number1: number, number2: number) {// number1 is positive, number2 is negative

  if (number1 == 0 && number2 == 0)
    return 0.5;

  var result = number1 / (number1 + number2);

  return Math.trunc(result * 100);
}

export function getColorCodeFromDivision(number1: number, number2: number) {// number1 is positive, number2 is negative

  if (number1 == 0 && number2 == 0)
    return "#656c7b";

  var result = number1 / (number1 + number2);

  result = Math.round(result * 5);

  switch (result) {
    case 5: return "#47be7d";
    case 4: return "#47be7d";
    case 3: return "#ff9900";
    case 2: return "#ff9900";
    case 1: return "#f1416c";
    case 0: return "#f1416c";
    default: return "#ff9900";
  }
}

export function getEmojiFromDivision(number1: number, number2: number) {// number1 is positive, number2 is negative

  var result = number1 / (number1 + number2);

  result = Math.round(result * 5);

  switch (result) {
    case 5: return "😊";
    case 4: return "😊";
    case 3: return "😐";
    case 2: return "😐";
    case 1: return "😡";
    case 0: return "😡";
    default: return "😐";
  }
}

export function textOverflowWithEllipsis(string: string, endIndex: number = 15) {

  if (string.length > endIndex) {
    return string.substring(0, endIndex) + '...';
  }
  return string;
}

export function dateCleaner(date: any): any {
  return date == null ? null : date[0].getFullYear() + "-" + date[0].getMonth() + "-" + date[0].getDate();
}

export function convertDateTimeFormat(date: any, format: any = "tr"): string {
  var dateParts = date == null ? null : date.split("-")
  var dateParts2 = date == null ? null : dateParts[2].split(" ")
  return date == null ? "" : dateParts2[0] + "." + dateParts[1] + "." + dateParts[0];
}

export function parseDateTimeFormat(date: any, format: any = "tr"): Date {
  var dateParts = date == null ? null : date.split(".")
  const utcDate: Date = new Date(Date.UTC(dateParts[2], dateParts[1], dateParts[0], 0, 0, 0));
  return utcDate;
}

export function normalizeLinkedinUsername(rawUsername: string): string {
  if (!rawUsername) return '';

  if (rawUsername.startsWith('school/')) {
    return rawUsername.substring('school/'.length);
  }
  if (rawUsername.startsWith('company/')) {
    return rawUsername.substring('company/'.length);
  }
  return rawUsername;
}

export function getChannelImageUrl(channelType: number | string) {
  let url = "";
  switch (channelType) {
        case 2: url = "/media/svg/brand-logos/twitter.svg"; break;
        case 3: url = "/media/svg/brand-logos/sikayetvar.png"; break;
        case 4: url = "/media/svg/brand-logos/facebook-3.svg"; break;
        case 5: url = "/media/svg/brand-logos/eksisozluk.svg"; break;
        case 6: url = "/media/svg/brand-logos/icons8-chatbot-96.png"; break;
        case 7: url = "/media/svg/brand-logos/instagram-2-1.svg"; break;
        case 8: url = "/media/svg/brand-logos/youtube.svg"; break;
        case 9: url = "/media/svg/brand-logos/reddit.svg"; break;
        case 10: url = "/media/svg/brand-logos/instagram-comments.png"; break;
        case 11: url = "/media/svg/brand-logos/tiktok-sharing.png"; break;
        case 12: url = "/media/svg/brand-logos/tiktok-comments.png"; break;
        case 13: url = "/media/svg/brand-logos/linkedin-2.svg"; break;
        case 14: url = "/media/svg/brand-logos/linkedin-comments.png"; break;

        case 15: url = "/media/svg/brand-logos/linkedin-2.svg"; break;
        case 16: url = "/media/svg/brand-logos/twitter.svg"; break;
        case 17: url = "/media/svg/brand-logos/youtube.svg"; break;
        case 18: url = "/media/svg/brand-logos/instagram-2-1.svg"; break;
        case 19: url = "/media/svg/brand-logos/tiktok-sharing.png"; break;
        case 20: url = "/media/svg/newspaper-icons/newspaperBlueLight.svg"; break;

        case 21: url = "/media/svg/brand-logos/youtube.svg"; break;
        case 22: url = "/media/svg/brand-logos/twitter.svg"; break;

        case 26: url = "/media/svg/brand-logos/facebook-3.svg"; break;
        case 27: url = "/media/svg/brand-logos/facebook-3.svg"; break;
        case 28: url = "/media/svg/brand-logos/facebook-3.svg"; break;

        case "100":
        case 100: url = "/media/svg/custom-logos/online-meeting-conversations-v2.webp"; break;
        case 101: url = "/media/svg/brand-logos/google-meet.svg"; break;
        case 102: url = "/media/svg/brand-logos/microsoft-teams.svg"; break;
        case 103: url = "/media/svg/brand-logos/zoom.svg"; break;
        case 104: url = "/media/svg/brand-logos/twitter.svg"; break;
        case 105: url = "/media/svg/brand-logos/instagram-2-1.svg"; break;
        case 106: url = "/media/svg/brand-logos/facebook-3.svg"; break;
        case 107: url = "/media/svg/brand-logos/whatsapp.svg"; break;
        case 108: url = "/media/svg/brand-logos/slack-new-logo.svg"; break;
        case 109: url = "/media/svg/brand-logos/skype.svg"; break;

        case 202: url = "/media/svg/custom-logos/booking.svg"; break;

        default: url = "/media/svg/general/api-cloud.svg"; break;
      }

  return url;
}
